/*@flow*/
import type { Element } from 'react';
import React from 'react';

export default function Item(locals: {
  label: React$Node,
  children: React$Node,
}): Element<'div'> {
  return (
    <div className="grid-row">
      <div className="grid-col">
        <h6>{locals.label}</h6>
        {locals.children}
      </div>
    </div>
  );
}
